import { gql, useQuery } from "@apollo/client";
import { useModals } from "ModalProvider";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { BsPencil } from "react-icons/bs";
import LinkForm from "./LinkForm";
import ShortenLinkQRCode from "./ShortenLinkQRCode";

export const FETCH_ALL_LINKS = gql`
  query FETCH_ALL_LINKS {
    allLinks {
      id
      name
      slug
      shorternLink
      originLink
      description
      updatedAt
      createdAt
      visitedCount
      createdBy {
        id
        email
      }
    }
  }
`;

const Shortlinks = () => {
  const { loading, error, data } = useQuery(FETCH_ALL_LINKS);

  const { present, hide } = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <Page
      staticHeader
      title="Short Links"
      rightButtons={
        <Button
          onClick={() =>
            present({
              title: "Create Link",
              center: true,
              children: <LinkForm hide={hide} />,
            })
          }
        >
          + New Link
        </Button>
      }
    >
      <div className="p-4 lg:p-6 grid grid-cols-12 gap-6">
        <div className="card py-0 col-span-8 divide-y divide-gray-100 dark:divide-gray-700">
          {data.allLinks.map((link) => (
            <div key={link.id} className="py-8">
              <div>
                <div className="flex justify-between items-center">
                  <Button
                    onClick={() =>
                      present({
                        title: "Edit Link",
                        center: true,
                        children: <LinkForm link={link} hide={hide} />,
                      })
                    }
                  >
                    <div className="flex items-center space-x-2">
                      <h4>{link.name}</h4>
                      <BsPencil size={16} />
                    </div>
                  </Button>
                  <div className="opacity-70 ">
                    {link.createdBy.email} at{" "}
                    {moment(link.createdAt).format("YYYY-MM-DD HH:mm")}
                  </div>
                </div>

                <div className="-mx-2 mt-2">
                  <table>
                    <tbody>
                      <tr className="">
                        <td>
                          <label>Shorten Link:</label>
                        </td>
                        <td className="w-full">
                          <a
                            href={link.shorternLink}
                            target="_blank"
                            rel="noreferer"
                          >
                            {link.shorternLink}
                          </a>
                        </td>
                      </tr>
                      <tr className="">
                        <td>
                          <label>Origin Link:</label>
                        </td>
                        <td className="w-full">
                          {link.originLink ? (
                            <a
                              href={link.originLink}
                              target="_blank"
                              rel="noreferer"
                            >
                              {link.originLink}
                            </a>
                          ) : (
                            <span className="text-gray-500">Not Set</span>
                          )}
                        </td>
                      </tr>
                      {link.description ? (
                        <tr className=" whitespace-pre-wrap">
                          <td className="align-baseline">
                            <label>Description</label>
                          </td>
                          <td>{link.description}</td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mt-4">
                <h5>QR Code</h5>
                <div className="mt-2">
                  <ShortenLinkQRCode
                    name={link.name}
                    shorternLink={link.shorternLink}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="col-span-4">
          <div className="card">
            <h4>Visits</h4>
            <Ranking links={data.allLinks} />
          </div>
        </div>
      </div>
    </Page>
  );
};

const Ranking = ({ links }) => {
  const sortedLinks = [...links].sort(
    (a, b) => b.visitedCount - a.visitedCount,
  );

  return (
    <div>
      {sortedLinks.map((link) => (
        <div
          key={link.id}
          className="border-b dark:border-gray-700 py-2 space-x-8 justify-between flex items-center"
        >
          <div>{link.name}</div>
          <div>{link.visitedCount}</div>
        </div>
      ))}
    </div>
  );
};

export default Shortlinks;
